import { getData, apiRequest } from '../apiClient';

// get all users for role assignment

export const getUsersForRoleAssign = async () => {
  try {
      const result = await getData("/role/access/user/getuser");
      return {
          data: {
              message: result.message,
              success: true,
              data: result.data
          }
      };
  } catch (error) {
      console.error('Get users for role assign API error:', error);
      return {
          data: {
              success: false,
              error: error.message
          }
      };
  }
};

// get all roles for role assignment
export const getRolesForRoleAssign = async () => {
    try {
        const result = await getData("/role/access/user/getrole");
        return {
            data: {
                message: result.message,
                success: true,
                data: result.data
            }
        };
    } catch (error) {
        console.error('Get roles for role assign API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};

// get role access users with pagination
export const getRoleAccessUsersWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
      const queryParams = new URLSearchParams({
        page: String(page),
        limit: String(limit),
        search: search,
      });
  
      const result = await getData(`/role/access/user/get?${queryParams}`, {}, {}, signal);
      return {
        success: true,
        ...result,
      };
    } catch (error) {
      console.error("Get role access users with pagination API error:", error);
      return {
        success: false,
        ...error,
      };
    }
  };

// get roles assigned to a specific user
export const getUserRoles = async ({ id }) => {
    try {
        const result = await getData(`/role/access/user/getbyuser/${id}`);
        return {
            data: {
                message: result.message,
                success: true,
                data: result.data
            }
        };
    } catch (error) {
        console.error('Get user roles API error:', error.message);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};

// Bulk assign/remove roles to/from user
export const bulkAssignRoles = async ({ fk_user_id, add_roles = [], remove_roles = [] }) => {
    try {
      let results = [];
      
      if (add_roles.length > 0) {
        const payload = { fk_user_id, role_ids: add_roles };
        const result = await apiRequest("post", "/role/access/user/add", payload);
        results.push(result);
      }

      if (remove_roles.length > 0) {
        const payload = { fk_user_id, role_ids: remove_roles };
        const result = await apiRequest("delete", "/role/access/user/remove", payload);
        results.push(result);
      }
  
      return {
        data: {
          message: "Roles updated successfully",
          success: true,
          data: results,
        },
      };
    } catch (error) {
      console.error('Bulk assign roles API error:', error);
      return {
        data: {
          success: false,
          error: error.message,
        },
      };
    }
  };
  
